export function getContactInfo(value) {
  if (value.public_user?.account?.email) {
    return value.public_user.account.email
  }

  if (value.preferred_contact_methods.length === 0) {
    return '-'
  }

  // return email if there otherwise fallback to phone
  let email = value.preferred_contact_methods.find(v => v.email !== null)
  if (email) return email.email.address

  let phone = value.preferred_contact_methods.find(v => v.phone !== null)
  if (phone) return phone.phone.number

  // no phone or email. only address is there.
  return '-'
}
